export const companyProjets = [
  {
    id: 1,
    title: "Lawyer Wangu",
    img: "assets/lw.PNG",
    link: "https://www.lawyerwangu.com/",
  },
  {
    id: 2,
    title: "Abayabuth",
    img: "assets/abayabuth.PNG",
    link: "https://abayabuth.com/",
  },
  {
    id: 3,
    title: "indiaswedenic",
    img: "assets/india-sweden.PNG",
    link: "https://www.indiaswedenic.com/",
  },
];

export const learningProjects = [
  {
    id: 1,
    title: "Netflix Clone",
    img: "assets/netflix_clone.PNG",
    link: "https://ott-platform-871ab.web.app/",
  },
  {
    id: 2,
    title: "Tinder Clone",
    img: "assets/tinder_clone.PNG",
    link: "https://tinder-clone-3fa99.web.app/",
  },
];

export const freelancingProjects = [
  {
    d: 1,
    title: "The Fit ip",
    img: "assets/fitzip.PNG",
    link: "https://thefitzip.com/fitzip-live",
  },
];
